import A11yHiddenBox from '@rover/kibble/styles/A11yHiddenBox';
import { getAbsoluteUrl } from '@rover/shared/js/utils/getFullUrl';

import MicrodataHTMLAttributes from './MicrodataHTMLAttributes';
import schema from './schema';

type Props = {
  indexUrl?: string;
  name?: string;
} & MicrodataHTMLAttributes;

const Brand: React.FC<Props> = ({ indexUrl, name = 'Rover', ...props }: Props) => (
  <A11yHiddenBox {...props} webProps={{ itemScope: true, itemType: schema`Brand` }}>
    <meta itemProp="name" content={name} />
    {indexUrl ? <meta itemProp="url" content={getAbsoluteUrl(indexUrl).toString()} /> : null}
  </A11yHiddenBox>
);

export default Brand;
